import { Button, Col, Form, InputNumber, Row, Select, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showMessage, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CSelect from "components/CSelect";
import { useEffect, useState } from "react";

const CreateLicense = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { fetch, get } = useAjax();
  const edit = state ? true : false;
  const [distributors, setDistributors] = useState([]);

  const onFinish = (values) => {
    const method = edit ? "put" : "post";
    const data = { ...values };
    fetch(method, "api/v1/licenses", { ...data })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            navigate("/devices/licenses");
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/lookups/distributorslineage")
      .then((resp) => {
        setDistributors(resp);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      layout="vertical"
      initialValues={{ ...state, active: !edit ? true : state.active }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="Distributor"
            name="companyID"
            rules={[{ required: true }]}
          >
            <CSelect allowClear={true} dropdownMatchSelectWidth={false}>
              {distributors.map((r) => (
                <Select.Option key={r.value} value={r.value}>
                  {r.text}
                </Select.Option>
              ))}
            </CSelect>
          </Form.Item>
          <Form.Item
            label="Quantity"
            name="quantity"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} precision={0} />
          </Form.Item>
          <Form.Item
            label="Valid days"
            name="validDays"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} precision={0} />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Generate license
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/devices/licenses");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default CreateLicense;
